import { Module } from 'vuex';
import { RootState } from '../..';
import { Dashboard as state } from './state';
import { DashboardState } from './types';
import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

export const Dashboard: Module<DashboardState, RootState> = {
  state,
  mutations,
  actions,
  getters
};
